<script setup>
import {state} from "@/socket";
import AlertItem from "@/components/alerts/AlertItem.vue";
import useClickOutside from '@/composables/clickOutside'
import {onMounted, computed, watch, ref} from "vue";
import {useStore} from "vuex";
import {AlertApi} from "@/api/alerts";

const store = useStore()

const alerts = computed(() => store.getters.alerts || []);
const alert_count = computed(() => {
  return alerts.value.filter(alert => !alert.user || !alert.read).length
})
const no_read_alerts = computed(() => {
  return alerts.value.filter(x => !x.read).slice(0, 6)
})

const ws_state = computed(() => state.alert);

watch(ws_state, value => {
  const already = alerts.value.find(x => x.id === value.id);
  store.dispatch("updateAlert", value)
  if (!already) {
    alertCount.value.classList.add("animate__tada")
    playSound();
  }
})
onMounted(() => {
  store.dispatch("getAlerts")
})


const componentRef = ref()
const excludeRef = ref()
const dropdown = ref()
const alertCount = ref()
const isOpen = ref(false)
useClickOutside(
    componentRef,
    () => {
      isOpen.value = false
    },
    excludeRef
)

function playSound() {
  const audio = new Audio("https://reputation-analytics.ru/media/static/front/bell.wav");
  // audio.volume = 1;
  const promise = audio.play();
  if (promise) {
    promise.catch(function (error) {
      console.error(error);
    });
  }
}

function setAllRead() {
  // dropdown.value.classList.remove('show');
  AlertApi.set_all_read().then(()=>{
    store.dispatch("getAlerts")
  })

}

function removeTada() {
  alertCount.value.classList.remove('animate__tada')
}


</script>
<template>

  <div class="dropdown">
    <button type="button" ref="alertCount" class="btn dropdown-toggle"
            @click="removeTada"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside">
      <i class="bi bi-bell"></i> <span :class="'badge'+(alert_count?' text-bg-danger':'')"> {{ alert_count }}</span>
    </button>
    <ul class="dropdown-menu dropdown-menu-end" ref="dropdown">
      <template v-for="alert in isOpen?alerts:no_read_alerts">
        <AlertItem :alert="alert"></AlertItem>
      </template>

      <li class="list-group-item list-group-item-action d-flex gap-3 p-3" aria-current="true"
          v-if="!no_read_alerts.length">
        <p class="mb-0 opacity-75">Нет непрочитанных событий</p>
      </li>
      <button ref="excludeRef"
              class="btn btn-sm btn-outline-dark show-all"
              v-if="alerts.length > 6" @click="isOpen = !isOpen;">
        <template v-if="isOpen">Скрыть</template><template v-else>Показать все</template>
      </button>
    </ul>


  </div>

</template>

<style scoped>
.collapse{
  .dropdown{
    display: none;
  }
}

.dropdown {
  color: #000000;
  width: 40px;
  height: 40px;
  text-align: center;

  .dropdown-toggle {
    width: 40px;
    height: 40px;
    background: var(--soft-grey);
    color: var(--grey);

    &:after {
      display: none;
    }
    .badge{
      position: absolute;
      &:not(.text-bg-danger){
        color: transparent;
      }
    }
  }
}

.dropdown-menu {
  width: 220px;
  z-index: 10000;
  padding-top: 0;
  max-height: 70vh;
  overflow-y: scroll;

  .list-group-item {
    padding: 10px;
  }

  .show-all {
    margin-top: auto;
    position: sticky;
    bottom: -11px;
    background-color: white;
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-bottom: none;
    width: 100%;
    z-index: 10;
    &:hover{
      color: #000000;
    }
  }
}

.all-alerts {
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100000;

  .dropdown-menu {
    padding-top: 0;
    max-height: 100vh;
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    overflow-y: auto;
  }
}

.animate__tada {
  animation: wiggle 2s linear infinite;
}

@keyframes wiggle {
  0%, 7% {
    transform: rotateZ(0);
  }
  15% {
    transform: rotateZ(-15deg);
  }
  20% {
    transform: rotateZ(10deg);
  }
  25% {
    transform: rotateZ(-10deg);
  }
  30% {
    transform: rotateZ(6deg);
  }
  35% {
    transform: rotateZ(-4deg);
  }
  40%, 100% {
    transform: rotateZ(0);
  }
}



</style>
